import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { AccountCreateEditRequest, IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useAccountMutations(accountId?: string, componentName = "useAccountMutations") {
  const { put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const update = useMutation(
    (account: AccountCreateEditRequest) =>
      put<AccountCreateEditRequest, DefaultResponseWithData<IAccount>>(
        `/account/${accountId}`,
        account
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );

  // Staff-level edit for haulier accounts only; the API refuses any other account through it.
  const updateHaulier = useMutation(
    (account: AccountCreateEditRequest) =>
      put<AccountCreateEditRequest, DefaultResponseWithData<IAccount>>(
        `/account/haulier/${accountId}`,
        account
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );

  return {
    update,
    updateHaulier,
  };
}
